import { ColorSwitcher } from "@/shared/ui";
import CreateCharacterBtnRandom from "@/domains/createCharacter/components/CreateCharacterBtnRandom";

type Props = {
  variants: string[];
  value: number;
  onChange: (value: number) => void;
  label: string;
};

export default function CreateCharacterColorSwitcher({ variants, value, onChange, label }: Props) {
  return (
    <div className="bg-dark-800 shrink-0 gap-px flex justify-between items-center rounded-xl h-13.5 pl-5 pr-2">
      <div className="font-bold mr-auto text-15">{label}</div>
      <ColorSwitcher value={value} variants={variants} onChange={onChange} />
      <CreateCharacterBtnRandom variants={variants} onClick={onChange} returnIndex />
    </div>
  );
}
